import React from 'react';
import Navbar1 from '../../Navbar/Navbar1/Navbar1';
import Footer from '../../Footer/Footer';
import './Services2.css';
import { FaMicrochip, FaChartLine, FaNetworkWired, FaRobot, FaLightbulb, FaBolt, FaWifi, FaShip, FaGasPump, FaWrench, FaUsers, FaCog, FaEye, FaShieldAlt, FaDatabase, FaCheckCircle } from 'react-icons/fa';
import { Gi3DGlasses, Gi3DStairs, Gi3DHammer, Gi3DMeeple, Gi3DGoggles, Gi3DStar } from 'react-icons/gi';
import { FaStar } from 'react-icons/fa';



const Services2 = ({ onNavigate }) => {
  return (
    <>
      <Navbar1 onNavigate={onNavigate} />
      <div className="services2-hero">
        <p className="services2-subheading">Shipshape Chief™</p>
        <h1 className="services2-heading">Vessel Performance Optimisation</h1>
        <p className="services2-description">
          Empowering technical and operations teams with real-time access to propulsion, auxiliary, navigational,
          and cargo control parameters. Your Remote Bridge, Engine Room, and Cargo Control Room.
        </p>
                  <button className="services2-btn" onClick={() => onNavigate('contact')}>Book Demo</button>

        <div className="services2-tags">
          <span>Real-time Control</span>
          <span>Condition-based Maintenance</span>
          <span>Operational Excellence</span>
        </div>
      </div>


      <div className="services2-what-is-vpo">
        <div className="services2-left">
            <h2>What is Vessel Performance Optimisation?</h2>
            <p className="services2-left-description">
            Vessel Performance Optimisation is the continuous process of monitoring, analysing, and improving how
            a vessel operates. With real-time insights, predictive maintenance, and fleet-wide benchmarking,
            operators can achieve operational excellence.
            </p>
            <ul className="services2-left-list">
            <li>Reduce fuel and energy consumption</li>
            <li>Improve CII and ESG scores</li>
            <li>Avoid off-hire claims</li>
            <li>Enable smarter condition-based maintenance</li>
            <li>Maintain a high-fidelity, dynamic digital profile</li>
            </ul>
        </div>

        <div className="services2-right-card">
            <h4>Digital Twin Technology</h4>
            <p>
            Shipshape Chief™ forms the data backbone of your vessel’s digital operations, feeding high-frequency,
            validated data into your digital twin for enhanced accuracy and intelligence.
            </p>
        </div>
        </div>

        {/* <div className="services2-chief-features">
        <h2 className="services2-chief-features-heading">What Does Shipshape Chief™ Include?</h2>
        
        <div className="services2-chief-cards">
            <div className="chief-feature-card">
            <FaMicrochip className="chief-icon" />
            <h4>Onboard Data Capture Hub</h4>
            <p>
                Rugged edge computer and marine-certified PLCs installed onboard every vessel with secure data streaming.
            </p>
            </div>

            <div className="chief-feature-card">
            <FaChartLine className="chief-icon" />
            <h4>Live Parameter Monitoring</h4>
            <p>
                Real-time monitoring of main engine, auxiliaries, boilers, bridge systems, and cargo control parameters..
            </p>
            </div>

            <div className="chief-feature-card">
            <FaNetworkWired className="chief-icon" />
            <h4>Shore Dashboard Access</h4>
            <p>
                Cloud-based real-time dashboard for technical & fleet teams with live alerts and historical trends.
            </p>
            </div>

            <div className="chief-feature-card">
            <FaRobot className="chief-icon" />
            <h4>AI Analytics via Shipshape IQ™</h4>
            <p>
                Machine learning for deviation detection, ship-specific benchmarks, and predictive maintenance recommendations.
            </p>
            </div>
        </div>
        </div> */}
        <div className="services2-chief-features">
        <h2 className="services2-chief-features-heading">What Does Shipshape Chief™ Deliver?</h2>
        
        <div className="services2-chief-cards">
            <div className="chief-feature-card">
            <FaMicrochip className="chief-icon" />
            <h4>Unified Data Workspace</h4>
            <p>
               Aggregate and organize operational, voyage, fuel, emissions, and fleet data into a single source of truth for analysis and decision-making.
            </p>
            </div>

            <div className="chief-feature-card">
            <FaChartLine className="chief-icon" />
            <h4>Operational Performance Visibility</h4>
            <p>
               Monitor key operational metrics through real-time and historical insights, enabling better fleet oversight and performance tracking.
            </p>
            </div>

            <div className="chief-feature-card">
            <FaNetworkWired className="chief-icon" />
            <h4>Cloud-Based Fleet Intelligence</h4>
            <p>
                Access dashboards, alerts, trends, and reports from anywhere through a centralized cloud platform designed for fleet and technical teams.
            </p>
            </div>

            <div className="chief-feature-card">
            <FaRobot className="chief-icon" />
            <h4>AI-Powered Analytics</h4>
            <p>
                Leverage machine learning to identify inefficiencies, detect anomalies, benchmark performance, and support data-driven operational decisions.            </p>
            </div>
        </div>
        </div>


        <div className="services2-live-monitoring">
        <h2 className="monitoring-heading">Live Parameter Monitoring</h2>

        <div className="monitoring-grid">
            <div className="monitoring-card">
            <h4>Main Engine</h4>
            <ul>
                <li><span className="green-dot" />RPM</li>
                <li><span className="green-dot" />Load</li>
                <li><span className="green-dot" />SFOC</li>
                <li><span className="green-dot" />Cylinder Pressure</li>
            </ul>
            </div>

            <div className="monitoring-card">
            <h4>Auxiliaries</h4>
            <ul>
                <li><span className="green-dot" />Run Hours</li>
                <li><span className="green-dot" />Generator Loading</li>
                <li><span className="green-dot" />Performance</li>
            </ul>
            </div>

            <div className="monitoring-card">
            <h4>Bridge Systems</h4>
            <ul>
                <li><span className="green-dot" />Trim</li>
                <li><span className="green-dot" />Heading</li>
                <li><span className="green-dot" />Weather</li>
                <li><span className="green-dot" />Nav Data</li>
            </ul>
            </div>

            <div className="monitoring-card">
            <h4>Boilers</h4>
            <ul>
                <li><span className="green-dot" />Burner Usage</li>
                <li><span className="green-dot" />Steam Rates</li>
                <li><span className="green-dot" />Energy Balance</li>
            </ul>
            </div>

            <div className="monitoring-card">
            <h4>Cargo Control</h4>
            <ul>
                <li><span className="green-dot" />Tank Temperatures</li>
                <li><span className="green-dot" />Pressure</li>
                <li><span className="green-dot" />Inert Gas</li>
                <li><span className="green-dot" />Ballast</li>
            </ul>
            </div>
        </div>
        </div>


        <div className="services2-features">
        <h2 className="services2-features-title">Key Features & Benefits</h2>
        <div className="features-grid">
            {[
            {
                title: 'Fuel Efficiency Tracking',
                desc: 'Identify and resolve inefficiencies faster',
                icon: <Gi3DGlasses />
            },
            {
                title: 'Condition-Based Maintenance',
                desc: 'Reduce failures, improve uptime',
                icon: <Gi3DHammer />
            },
            {
                title: 'Verified Compliance Support',
                desc: 'Generate reliable input for CII, FuelEU, ETS modules',
                icon: <FaStar />
            },
            {
                title: 'Fleet Comparisons',
                desc: 'Benchmark similar vessels across geographies or voyages',
                icon: <FaUsers />
            },
            {
                title: 'Future-Proof Integration',
                desc: 'Works seamlessly with your PMS, ERP, and compliance platforms',
                icon: <FaCog />
            },
            {
                title: 'Live Machinery & Cargo Monitoring',
                desc: 'Instant status from shore—support vessels remotely',
                icon: <FaEye />
            },
            ].map((item, idx) => (
            <div className="feature-card" key={idx}>
                <div className="feature-icon-wrap">
                {item.icon}
                </div>
                <div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
                </div>
            </div>
            ))}
        </div>
        </div>



     {/* Designed for Maritime Reality Section */}
     <div className="services2-maritime-section">
        <h2 className="services2-maritime-heading">Designed for Maritime Reality</h2>
        <div className="services2-maritime-grid">
          <div className="services2-maritime-item">
            <div className="services2-maritime-icon"><FaBolt /></div>
            <h4>Shockproof</h4>
            <p>Vibration-resistant hardware</p>
          </div>
          <div className="services2-maritime-item">
            <div className="services2-maritime-icon"><FaWifi /></div>
            <h4>Real-time</h4>
            <p>Encrypted transmission</p>
          </div>
          <div className="services2-maritime-item">
            <div className="services2-maritime-icon"><FaDatabase /></div>
            <h4>Offline Ready</h4>
            <p>Data buffering ensures no data loss</p>
          </div>
          <div className="services2-maritime-item">
            <div className="services2-maritime-icon"><FaCheckCircle /></div>
            <h4>Compatible</h4>
            <p>Cross-vessel compatibility</p>
          </div>
        </div>
      </div>


      {/* Works Seamlessly with Shipshape Captain Section */}
      <div className="services2-captain-section">
        <h2 className="services2-captain-heading">
          Works Seamlessly with Shipshape Captain<sup>™</sup>
        </h2>

        <div className="services2-captain-card">
          <p className="services2-captain-toptext">
            Shipshape Chief<sup>™</sup> is the data engine behind your voyage optimisation strategy.
            <br />
            It powers and enhances your Shipshape Captain<sup>™</sup> platform — ensuring the voyage simulation,
            weather routing, fuel planning, and CII projections are based on high-fidelity, vessel-specific,
            real-world inputs.
          </p>

          <div className="services2-captain-comparison">
            <div className="services2-captain-left">
              <strong>Shipshape Captain<sup>™</sup></strong>
              <p>Plans the route</p>
            </div>
            <div className="services2-captain-arrow">➜</div>
            <div className="services2-captain-right">
              <strong>Shipshape Chief<sup>™</sup></strong>
              <p>Makes sure it’s optimised</p>
            </div>
          </div>
        </div>

        <p className="services2-captain-footnote">
          <strong>A smart captain needs a smart ship.</strong>
          <br />
          Part of the Shipshape IQ<sup>™</sup> suite, powering Shipshape Captain<sup>™</sup>.
        </p>
      </div>


            {/* CTA Final Section */}
            <div className="services2-cta-section">
        <h2 className="services2-cta-heading">
          Ready to Elevate Your Fleet&apos;s Performance?
        </h2>
        <p className="services2-cta-subtext">
          Book a demo today to see how Shipshape Chief<sup>™</sup> can streamline operations, reduce fuel burn, and
          transform your vessels into smart, compliant, and efficient assets.
        </p>
                    <button className="services2-cta-button" onClick={() => onNavigate('contact')}>Schedule Demo</button>
        <p className="services2-cta-footnote">
          Shipshape Chief<sup>™</sup> — Real-time control. Condition-based maintenance. Operational excellence.
        </p>
      </div>


      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Services2;
